import { useMemo } from 'react';

import VideoPreview from 'components/global/VideoPreview';

import useLocale from 'hooks/useLocale';
import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

const VideoPreviewComponent = ({ fileName }) => {
	const { LanguageCode } = useLocale();
	const isMobile = useMediaQuery(Breakpoints.tablet);

	const videoLink = useMemo(() => {
		return `https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingStepsPreview/${isMobile ? 'mobile' : 'desktop'}/${LanguageCode}/${fileName}.mp4`;
	}, [fileName, LanguageCode, isMobile]);

	return <VideoPreview videoLink={videoLink} />;
};

export default VideoPreviewComponent;
